import { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { formEndpoints } from '../../services/api/endpoints/form.endpoint';
import { Form } from '../../types/form';
import { logger } from '../../utils/logger';

export const useForms = () => {
  const [forms, setForms] = useState<Form[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const selectedOrganizationId = useSelector(
    (state: RootState) => state.organizationContext.selectedOrganizationId
  );

  const fetchForms = useCallback(async () => {
    if (!selectedOrganizationId) return;

    setIsLoading(true);
    setError(null);

    try {
      const data = await formEndpoints.listForms(selectedOrganizationId);
      setForms(data);
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to fetch forms';
      setError(message);
      logger.error('Error fetching forms:', err);
    } finally {
      setIsLoading(false);
    }
  }, [selectedOrganizationId]);

  useEffect(() => {
    fetchForms();
  }, [fetchForms]);

  return {
    forms,
    isLoading,
    error,
    selectedOrganizationId,
    refetch: fetchForms,
  };
};
